<template>
  <div class="diamond-certificate">
    <DiamondCertificateChecker
      v-if="!diamondCertificate"
      @setDiamondResponse="setDiamondResponse"
    />
    <DiamondCertificateDetails v-else :result="diamondCertificate" />
  </div>
</template>

<script lang="ts" setup>
import DiamondCertificateChecker from '@components/Diamonds/DiamondCertificate/DiamondCertificateChecker.vue';
import { ref } from 'vue';
import DiamondCertificateDetails from '@components/Diamonds/DiamondCertificate/DiamondCertificateDetails.vue';
import type { IDiamondCertificateResponse } from '@components/Diamonds/DiamondCertificate/IDiamondCertificate';

const diamondCertificate = ref<IDiamondCertificateResponse>();

const setDiamondResponse = (response: IDiamondCertificateResponse) => {
  diamondCertificate.value = response;
};
</script>

<style lang="scss" scoped>
.diamond-certificate {
  @include block-mb;
}
</style>
